import React from 'react';

import Styled from '../Modal.styles';

import { ModalPayloadType } from '@/types/ReduxTypes';

type Props = {
  payload: ModalPayloadType['GENERIC_MODAL']
  onClose: () => void;
};

const GenericModal: React.FC<Props> = (props: Props) => {
  const {
    onClose,
    payload: {
      headerText,
      primaryButtonText,
      secondaryButtonText,
      onClickPrimaryButton,
      onClickSecondaryButton,
      body,
    },
  } = props;

  const handleClickSecondary = () => {
    onClose();
    if (onClickSecondaryButton) {
      onClickSecondaryButton();
    }
  };
  const handleClickPrimary = () => {
    onClose();
    if (onClickPrimaryButton) {
      onClickPrimaryButton();
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <Styled.DialogContent>
        <Styled.TextContainer>
          <Styled.HeaderText>
            {headerText}
          </Styled.HeaderText>
          {body}
        </Styled.TextContainer>
        <Styled.ButtonContainer>
          {secondaryButtonText && (
            <Styled.NoButton onClick={handleClickSecondary}>
              <Styled.NoButtonText>
                {secondaryButtonText}
              </Styled.NoButtonText>
            </Styled.NoButton>
          )}
          {primaryButtonText && (
            <Styled.YesButton onClick={handleClickPrimary}>
              <Styled.YesButtonText>
                {primaryButtonText}
              </Styled.YesButtonText>
            </Styled.YesButton>
          )}
        </Styled.ButtonContainer>
      </Styled.DialogContent>
    </div>
  );
};

export default GenericModal;
